
(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();
    var $testimonialSlideList = $(".don-testimonial-slider");
    var resizeTimer;

    function setSameHeight() {
        var $body = $('body');

        // iterate over all sliders
        $testimonialSlideList.each(function () {
            var $currentTestimonialSlider = $(this);
            var $testimonialSlides = $currentTestimonialSlider.find('.don-testimonial-slider__container');
            
            // skip if no slides in widget
            if (!$testimonialSlides.length) {
                return;
            }

            var maxTopicHeight = 0;
            var $testimonialSliderItems = $currentTestimonialSlider.find(".don-testimonial-slider__item");

            // force block during measurement
            $testimonialSliderItems.addClass("d-block");

            // iterate over all slides of a single widget
            $testimonialSlides.each(function () {
                // remove styles added on first page load
                var $testimonialSlide = $(this);
                $testimonialSlide.removeAttr('style');
                // find maxTopicHeight
                maxTopicHeight = $testimonialSlide.height() > maxTopicHeight ? $testimonialSlide.height() : maxTopicHeight;
            });

            // remove force block during measurement
            $testimonialSliderItems.removeClass("d-block");

            // skip if xs. Removal of added style attribute has to be done before skipping!
            var isSm = $body.hasClass('is-sm');
            if (!isSm) {
                return;
            }

            // set max heights
            $testimonialSlides.each(function () {
                $(this).height(maxTopicHeight);
            });
        })
    }

    // measure and set same height again if window is resized
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setSameHeight();
        }, 200);
    });

    // set same height if content is loaded
    $(window).on("load", setSameHeight);
})(window, document, jQuery);
